import { defineStore } from 'pinia';
import i18n from '@/plugins/vue-i18n';

const defaultErrorMessageColour = '#d7534e';
const defaultWarningMessageColour = '#CA7C00';

export const useSnackbarStore = defineStore('snackbar', {
  state: () => ({
    content: '',
    color: '',
  }),
  actions: {
    showSnackbar({ color = defaultErrorMessageColour, content }) {
      this.content = content;
      this.color = color;
    },
    showSuccess(content = '') {
      this.showSnackbar({ color: 'success', content });
    },
    showWarning(content) {
      this.showSnackbar({
        color: defaultWarningMessageColour,
        content: content || i18n.t('errors.generalErrorMessage'),
      });
    },
    showError(content = '') {
      this.showSnackbar({ color: defaultErrorMessageColour, content });
    },
  },
});
